import React from 'react'
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import '../styles/Home.css'
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { toolsList } from '../data/toolsData';

const Home = () => {
  // Get only the first 4 tools for display on homepage
  const featuredTools = toolsList.slice(0, 4);
  
  return (
    <div className="page-gradient-background">
      <section className="hero-section">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <Badge bg="unknown" pill className="hero-badge mb-3">Powerful microtools for everyday tasks</Badge>
              <h1 className="hero-title">
                Supercharge Your <span className="text-highlight">Productivity</span> with MicroGenie
              </h1>
              <p className="hero-subtitle">
                Access powerful micro-tools that make everyday tasks faster, easier, and more efficient—all in one place.
              </p>
              <div className="hero-buttons">
                <Button as={Link} to="/tools" className="btn-primary hero-button me-3">
                  Explore Tools
                </Button>
                <Button as={Link} to="/about" variant="outline" className="btn-secondary hero-button">
                  Learn More
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Container className="tools-section">
        <h2 className="section-title dark-title">Powerful Micro-Tools</h2>
        <p className="section-subtitle text-center mb-5">
          Simple yet powerful tools designed to make your everyday tasks easier and more efficient.
        </p>
        <Row>
          {featuredTools.map(tool => (
            <Col md={6} lg={3} key={tool.id} className="mb-4">
              <Card className="tool-card">
                <Card.Body>
                  <div className="tool-icon">{tool.icon}</div>
                  <Card.Title className="tool-card-title">{tool.title}</Card.Title>
                  <Card.Text className="tool-card-text">
                    {tool.description}
                  </Card.Text>
                  <Button as={Link} to={tool.path} className="btn-primary">
                    <i className="la la-arrow-right" style={{ fontSize: '20px' }} aria-hidden="true"></i>
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-5">
          <Button as={Link} to="/tools" className="view-all-tools-btn">
            View All Tools <i className="la la-arrow-right" style={{ fontSize: '16px' }} aria-hidden="true"></i>
          </Button>
        </div>
      </Container>
    </div>
  )
}

export default Home